var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.108 22.0916L2 19.7206V3.6126L8.892 5.9126L15.923 1.8916L22 4.3226V20.4766L16.077 18.1066L9.109 22.0916H9.108ZM4 6.3916V18.2786L8 19.6116V7.7196L4 6.3916ZM14 5.2916L10 7.5796V19.2796L14 16.9916V5.2916ZM16.077 4.1056L16 4.1516V15.9226L20 17.5226V5.6756L16.077 4.1056Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapInactive);
export default __webpack_public_path__ + "static/media/map_inactive.4f16e4079532883119895f920699d9a9.svg";
export { ForwardRef as ReactComponent };